module.exports = __webpack_public_path__ + "static/dasmagazin-a865bc338a6cd418c12da9bf11ff7aa8.svg";